const getPrintPaperSize = state => state.printOptions.paperSize;

const getPrintOrientation = state => state.printOptions.orientation;

const getPrintScale = state => state.printOptions.scale;

export default {
  getPrintPaperSize,
  getPrintOrientation,
  getPrintScale
};
